<template>
  <div v-if="error">
    <div v-if="error">
      <div>
        <slot name="error" :error="error">
          <RequestPermissionsError
            :error-obj="error"
            :error="error.message"
          />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import useStreams from '@/compositions/useStreams';
import {
  nextTick, onMounted, watch, watchEffect,
} from '@vue/composition-api';
import RequestPermissionsError from './Permissions/RequestPermissionsError.vue';

export default {
  name: 'VideoRoomMediaErrors',
  components: { RequestPermissionsError },
  setup(props, { root }) {
    const { error } = useStreams();

    return {
      error,
    };
  },
};
</script>

<style lang="scss" scoped>
.video-room-modal-error {
  //max-width: 22.5rem;
  &__wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #F3F3F3;
    border-radius: 0.5rem;
    text-align: center;
    padding: 1.875rem 1.25rem;
    position: relative;
  }
  &__title {
    line-height: 1.25;
    color: #212121;
    padding: 0 1.25rem;
    margin-bottom: 0.625rem;
  }
  &__text {
    max-width: 20rem;
    font-size: 0.75rem;
    line-height: 1.67;
    color: #757575;
  }
  &__btn {
    background-color: #1fc57f;
    padding: 0.25rem 0.875rem 0.1875rem;
    font-size: 0.75rem;
    color: #FFFFFF;
    border-radius: 0.25rem;
    border: none;
    transition: filter ease-out 0.3s;
    &:focus, &:active, &:hover {
      outline: none;
      filter: brightness(1.15);
    }
  }
  &__close {
    border: none;
    background: transparent;
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
    &:hover, &:active {
      outline: none;
      svg path {
        stroke: #212121;
      }
    }
  }
}

</style>
